import "lenis/dist/lenis.css";

import Lenis from "lenis";

const lenis = new Lenis({
	autoRaf: true,
});

window.lenis = lenis;
